import React from 'react';
import AppTheme from '../theme/AppTheme';
import { useAppearance } from '../contexts/AppearanceContext';
import './mail-theme.css';

export default function MailTheme({ children }) {
  const { isDark } = useAppearance();
  return <AppTheme>
    <div className="mail-theme" data-theme={isDark ? 'dark' : 'light'}>{children}</div>
  </AppTheme>;
}
